<template>
  <div class="dialogue-action">
    <el-tooltip
      :disabled="!selectedContent"
      :visible-arrow="false"
      :content="selectedContent"
      placement="top"
    >
      <el-select
        v-close-on-zoom
        :value="state.selectedQuestion"
        :placeholder="placeholder"
        :disabled="readonly"
        class="question-select"
        @input="questionId => selectQuestion(questionId)"
      >
        <el-option
          v-for="question in getDialogueItems(emitter.caseConf)"
          :key="question.id"
          :label="question.content.en"
          :value="question.id"
        />
      </el-select>
    </el-tooltip>
    <div>
      <help-tooltip v-if="errors.length" type="error">
        <span v-for="error in errors" :key="error.message">{{ error.message }}</span>
      </help-tooltip>
    </div>
    <el-input
      v-if="aiEnabled"
      v-integer-only
      type="number"
      :disabled="readonly"
      :value="state.confidence"
      :min="1"
      :max="100"
      placeholder="Confidence"
      class="count-input"
      @change="value => updateConfidence(parseInt(value))"
    />
    <help-tooltip v-if="aiEnabled" type="info">
      Confidence (1 - 100) dictates how certain the AI is that question was asked
    </help-tooltip>
  </div>
</template>

<script>
import { get, uniqBy } from 'lodash';
import HelpTooltip from '../../common/components/HelpTooltip';

export default {
  name: 'dialogue-action',
  components: {
    HelpTooltip,
  },
  props: [
    'readonly',
    'emitter',
    'ikey',
    'getData',
    'putData',
    'control',
    'actionType',
    'placeholder',
    'getDialogueItems'
  ],
  data() {
    return {
      state: {
        selectedQuestion: undefined,
        confidence: undefined,
      },
    };
  },
  computed: {
    selectedContent() {
      const items = this.getDialogueItems(this.emitter.caseConf) || [];
      const item = items.find(i => i.id === this.state.selectedQuestion);
      return get(item, 'content.en');
    },
    errors() {
      if (!this.emitter.$store) {
        return [];
      }
      const errors = get(
        this.emitter.$store.getters['validation/errorsByFieldAndId'],
        `caseLogicDescription.${this.control.parent.id}`,
        [],
      ).filter(error => error.metadata && error.metadata.scope === 'control');

      return uniqBy(errors, 'message');
    },
    aiEnabled() {
      return this.actionType === 'AI_QUESTION';
    },
  },
  mounted() {
    this.syncState();
    this.emitter.on('process', (nodeOrControl) => {
      // Update internal state when the node data changes
      // outside (e.g. from a CallAction)
      if (nodeOrControl === this.control) {
        this.syncState();
      }
    });
    this.update();
  },
  methods: {
    syncState() {
      const data = this.getData(this.ikey);
      this.state.selectedQuestion = get(data, 'id');
      if (this.aiEnabled) {
        this.state.confidence = get(data, 'confidence');
      }
    },
    selectQuestion(questionId) {
      this.state.selectedQuestion = questionId;
      if (this.aiEnabled && !this.state.confidence) {
        this.state.confidence = 70; // Default confidence
      }
      this.update();
    },
    updateConfidence(confidence) {
      this.state.confidence = confidence;
      this.update();
    },
    update() {
      const data = {
        type: this.actionType,
        id: this.state.selectedQuestion,
      };
      if (this.aiEnabled) {
        data.confidence = this.state.confidence;
      }
      this.putData(this.ikey, data);
      this.emitter.trigger('process', this.control);
    }
  },
};
</script>

<style scoped>
.dialogue-action {
  display: grid;
  grid-template-columns: 1fr auto;
}
.help-tooltip {
  margin-top: 8px;
}
</style>
